module.exports = __webpack_public_path__ + "static/media/back_icn.c80e6d87.svg";